import React from 'react';
import {Box} from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  reducedPadding?: boolean;
}

export function TabPanel(props: TabPanelProps) {
  const {children, value, index, reducedPadding = false, ...other} = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}>
      {value === index && (
        <Box
          sx={{
            p: reducedPadding ? 0 : 1,
            pt: 0,
          }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}
